import type fr from "./locales/fr.json";

export enum SupportedLocales {
  FR = "fr",
  EN = "en",
}
export type MessageSchema = typeof fr;
